<template>
  <div>
    <template v-if="mode === 'DESIGN'">
      <el-input size="small" class="disabled-box" :placeholder="placeholder" :maxlength="100" show-word-limit :rows="2" type="textarea" />
    </template>
    <template v-else>
      <el-input v-if="!readerMode || perm==='E'" size="small" v-model="_value" :disabled="perm==='R'" clearable :maxlength="100" :placeholder="placeholder" show-word-limit :rows="3" type="textarea" />
      <!-- <el-input v-else size="small" v-model="_value" type="textarea" disabled /> -->
      <div v-else class="form-item-text" v-text="_value"></div>

    </template>
    <div v-if="isReplacement" class="total-time-con" :class="{'show-label': perm==='R'}">
      <span class="text">本月已补卡次数：</span>
      <span class="time">{{cardCount}}</span>
    </div>
  </div>
</template>

<script>
import componentMinxins from '../ComponentMinxins'
import approvalUserInfo from '../ApprovalUserInfo'
export default {
  mixins: [componentMinxins,approvalUserInfo],
  name: "TextareaInput",
  components: {},
  props:{
    value: {
      type: String,
      default: null
    },
    placeholder:{
      type: String,
      default: '请输入'
    },
    readerMode: {
      type: Boolean,
      default: false,
    },
  },
  computed: {
    _value: {
      get() {
        return this.value;
      },
      set(val) {
        this.$emit("input", val);
      }
    }
  },
  data() {
    return {}
  },
  methods: {}
}
</script>

<style scoped lang="scss">
.disabled-box /deep/.el-textarea__inner{
  padding-left: 8px;
}
 .total-time-con{
  padding-top: 6px;
  line-height: 1;
  // color: #2F3030;
  .text{
    color: #939696;
  }
  .time{
    color: #2F3030;
  }
}
.show-label{
    // position: absolute;
    margin:21px 0 15px -88px;
    .text{
      padding-right: 8px;
    }
  }
</style>
